
<script>
	import listBase from '@_system/components/base/list.vue'
	export default {
		extends: listBase,
		name: 'qualitytestpurchasebackIndex',
		props: {

		},
		data() {
			return {
				moduleName: 'qualitytestpurchaseback',
				windowName: '质检退换',
				windowType: 'modal',
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {

		},
		components: {
			
		}
	}
</script>
